'use strict';

var core = require('core/product/quickView');

/**
 * Overriding from main quickView.js since it was not an exported function
 * replaces the content in the popover for the selected product.
 */
 function fillPopoverElement(quickAddToCartUrl, popover) {
    var $popover = $('#' + popover);
    $.ajax({
        url: quickAddToCartUrl,
        method: 'GET',
        dataType: 'json',
        success: function(data) {
            $popover.find('.popover-body').html(data.renderedTemplate);
            $popover.popover('update');
            $('body').trigger('quickAddToCart:ready', $('.popover-body')); // sending custom event for slider init
        }
    });
}

core.showQuickAddToCart = function() {
    $('body').on('click', '.quick-add-to-cart', function (e) {
        e.preventDefault();
        var quickAddToCartUrl = $(this).closest('.quick-add-to-cart').data('url');
        var popover = $(this).closest('.quick-add-to-cart').attr('aria-describedby');
        $(e.target).trigger('quickAddToCart:show');
        fillPopoverElement(quickAddToCartUrl, popover);
    });
}

module.exports = core;
